export default __webpack_public_path__ + "static/media/html.6e930594.png";